import * as React from "react";
import { useEffect } from 'react';
import { IMapOptions } from "../interfaces/mapoptions";
import { useAppSelector } from "../store/index";
import { RootState } from "../reducers/index";
import { Ihalfway } from "../reducers/halfway";
import { logSearch } from "../api/log";

const DynamicMapGeocode = () => {
    const halfway = useAppSelector<Ihalfway>((x: RootState) => x.halfway);
    const mapoptions = useAppSelector<IMapOptions>((x: RootState) => x.mapoptions);

    // once the halfway has been fully calculated we log it
    useEffect(() => {
        if (halfway.startLatLng && halfway.endLatLng && halfway.latLng &&
            halfway.totalDistance && halfway.locationName && halfway.locationNameLong) {

            logSearch(halfway, mapoptions.token).catch(console.log);
        }
    }, [halfway.startLatLng, halfway.endLatLng, halfway.latLng,
        halfway.totalDistance, halfway.locationName, halfway.locationNameLong]);

    return null;
};

export default DynamicMapGeocode;
